<script setup lang="ts">
import {computed} from "vue";
import {Bell, Send} from "@lucide/vue";

const props = defineProps<{
    type: 'sms' | 'push',
    when: string;
}>();

const iconComponent = computed(() => {
    return props.type == 'sms' ? Send : Bell;
});
</script>

<template>
  <div class="text-primary font-bold flex items-center gap-x-1">
    <component :is="iconComponent" :size="20" />
    {{ when }}
  </div>
</template>

<style scoped>

</style>
